import React from "react";
import {Link} from "react-router-dom";

const Footer = () => {

    return (
        <footer>
		<div className="container">
			<div className="row">
				<div className="col-md-12">
					<ul className="footerNav">
						<li><Link to="/">©DirtMap {new Date().getFullYear()}</Link></li>
						<li><a href="mailto:mail@dirtmap.net">About</a></li>
						{/* <li><a href="mailto:mail@dirtmap.net">Contact</a></li> */}
						{/* <li><Link to="/about">About</Link></li>*/}
						<li><Link to="/contact">Contact</Link></li> 
						<li><Link to="/terms">T&C</Link></li>
						<li><Link to="/privacy">Privacy</Link></li>
					</ul>
				</div>
			</div>
		</div>
	</footer>
    )
}

export default Footer;